"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));

var _dateLocales = _interopRequireDefault(require("./../_utils/date-locales"));

var _intlDateTimeFormat = require("./../_utils/intl-date-time-format");

var arePropsEqual = function arePropsEqual(prevProps, nextProps) {
  return prevProps.dateTime === nextProps.dateTime && prevProps.endDateTime === nextProps.endDateTime && prevProps.locale === nextProps.locale;
};
/**
 * This component renders a localized date or date range using the Intl API.
 *
 * Note that for date ranges this will return a fragment containing two time
 * elements. If you need a single element in your markup you can wrap this
 * component in another element (e.g. a span).
 *
 * @since 5.x
 */


var DateTime = /*#__PURE__*/_react["default"].memo(function (props) {
  if (props.endDateTime) {
    var _intlDateTimeRangeFor = (0, _intlDateTimeFormat.intlDateTimeRangeFormat)((0, _parseISO["default"])(props.dateTime), (0, _parseISO["default"])(props.endDateTime), props.format, props.locale),
        _intlDateTimeRangeFor2 = (0, _slicedToArray2["default"])(_intlDateTimeRangeFor, 2),
        start = _intlDateTimeRangeFor2[0],
        end = _intlDateTimeRangeFor2[1];

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("time", {
      dateTime: props.dateTime
    }, start), end ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, " ", "- ", /*#__PURE__*/_react["default"].createElement("time", {
      dateTime: props.endDateTime
    }, end)) : null);
  } else {
    return /*#__PURE__*/_react["default"].createElement("time", {
      dateTime: props.dateTime
    }, (0, _intlDateTimeFormat.intlDateTimeFormat)((0, _parseISO["default"])(props.dateTime), props.format, props.locale));
  }
}, arePropsEqual);

DateTime.displayName = "DateTime";
DateTime.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The date/time to render. Any valid [ISO date or time string](https://www.iso.org/iso-8601-date-and-time-format.html)
   * is accepted. If no timezone is supplied then the client's local timezone will be assumed.
   */
  dateTime: _propTypes["default"].string.isRequired,

  /**
   * The end date/time if rendering a range. Any valid [ISO date or time string](https://www.iso.org/iso-8601-date-and-time-format.html)
   * is accepted. If no timezone is supplied then the client's local timezone will be assumed.
   */
  endDateTime: _propTypes["default"].string,

  /**
   * The format of the rendered date. See [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat)
   * for available values.
   *
   * NOTE: This cannot be changed after the component is mounted.
   */
  format: _propTypes["default"].object,

  /**
   * The locale to use for the date. See the [Intl API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl)
   * for more information about date internationalization in JS.
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"]))
} : {};
DateTime.defaultProps = {
  format: {
    day: "numeric",
    month: "short",
    year: "numeric"
  },
  locale: "en-US"
};
var _default = DateTime;
exports["default"] = _default;